<template>
  <span>
    <!-- Ajuste visual 3: height 2.4rem, el mismo alto que el círculo de la impresora -->
    <Button label="Ventas" :icon="icono" :badge="numero" :badgeSeverity="severidad"
      class="p-button-sm" :class="claseBoton" style="height: 2.4rem;" v-tooltip.bottom="textoEstado" @click="mostrarLista = true"
      data-testid="pos-ventas" />
    <Dialog v-model:visible="mostrarLista" header="Ventas de este equipo" modal :style="{ width: '900px' }">
      <!-- Línea de estado: el mismo contenido y colores que tenía la franja -->
      <!-- Etapa 3D: el borde rojo también con ventas antiguas o reloj desfasado; «en cola» cuenta solo las propias (D2 a). Antes:
           :class="conexion.ventasRechazadas > 0 ? 'border-red-500' : (conexion.ventasEnCola > 0 ? 'border-orange-500' : 'border-green-500')" -->
      <div class="flex justify-content-between align-items-center mb-2 p-2 border-round surface-100 border-1 text-sm" data-testid="ventas-estado"
           :class="hayAlerta ? 'border-red-500' : (conexion.ventasEnColaUsuario > 0 ? 'border-orange-500' : 'border-green-500')">
        <div class="flex flex-column">
          <!-- Etapa 3D (A): ventas antiguas, de otros usuarios y vencidas (D8: el texto indica reimprimir y entregar a administración) -->
          <span v-if="antiguasPropias > 0" class="text-red-500 font-bold"><i class="pi pi-history mr-1"></i>{{ antiguasPropias }} ventas sin enviar desde hace más de 60 h (la más antigua, de hace {{ Math.floor(conexion.horasVentaMasAntigua) }} h). El servidor las rechaza a las 72 h: conecte este equipo a internet hoy y pulse «Sincronizar ahora».</span>
          <span v-if="conexion.ventasAntiguasAjenas > 0" class="text-red-500 font-bold"><i class="pi pi-history mr-1"></i>{{ conexion.ventasAntiguasAjenas }} son de {{ cajerosAjenos }}: {{ cajerosAjenos }} debe iniciar sesión en este equipo, con conexión, para enviarlas.</span>
          <span v-if="conexion.ventasVencidas > 0" class="text-red-500 font-bold">{{ conexion.ventasVencidas }} ventas pasaron las 72 h: el servidor las rechazará. Reimprima cada ticket (botón 🖨 de la lista) y entréguelo a administración para registrarlas a mano.</span>
          <!-- Etapa 3D (B): reloj del equipo -->
          <span v-if="relojDesfasado" class="text-red-500 font-bold"><i class="pi pi-exclamation-circle mr-1"></i>{{ textoReloj }}<template v-if="conexion.desfaseVigente() > 0">. Las ventas sin conexión con la hora adelantada más de 5 min las rechaza el servidor</template></span>
          <!-- D2 (a): antes con conexion.ventasEnCola en las dos líneas siguientes -->
          <span v-if="conexion.sincronizando" class="text-orange-500 font-bold"><i class="pi pi-spin pi-spinner mr-1"></i>Sincronizando {{ conexion.ventasEnColaUsuario }} ventas…</span>
          <span v-else-if="conexion.ventasEnColaUsuario > 0" class="text-orange-500 font-bold"><i class="pi pi-clock mr-1"></i>{{ conexion.ventasEnColaUsuario }} por sincronizar</span>
          <span v-else class="text-green-600 font-bold"><i class="pi pi-check-circle mr-1"></i>Ventas al día</span>
          <span v-if="enColaAjenas > 0" class="text-600">{{ enColaAjenas }} de otros usuarios esperan a que ellos inicien sesión en este equipo</span>
          <span v-if="conexion.ventasRechazadas > 0" class="text-red-500 font-bold">{{ conexion.ventasRechazadas }} rechazadas: revise la lista</span>
          <span v-if="conexion.sesionExpirada && conexion.ventasEnCola > 0" class="text-red-500">Sesión vencida: inicie sesión para enviarlas</span>
          <span v-if="conexion.syncSinPermiso" class="text-red-500">Este usuario no tiene permiso para sincronizar ventas (Venta POS)</span>
          <!-- Etapa 4 (d): cierre de caja guardado en este equipo, sin enviar -->
          <span v-for="id in conexion.cajasConCierrePendiente" :key="'cierre-' + id" class="text-orange-500 font-bold" data-testid="ventas-cierre-pendiente"><i class="pi pi-lock mr-1"></i>Cierre de la caja #{{ id }} pendiente de enviar</span>
          <!-- Etapa 3D (B y D6): avisos en gris, solo con ventas en cola -->
          <span v-if="conexion.desfaseRelojMs === null && conexion.ventasEnCola > 0" class="text-500">No se pudo comprobar la hora de este equipo con el servidor</span>
          <span v-if="conexion.almacenamientoPersistente === false && conexion.ventasEnCola > 0" class="text-500">Este navegador podría borrar los datos guardados si falta espacio en disco</span>
        </div>
        <!-- D2 (a): antes v-if="conexion.ventasEnCola > 0 && …" (con solo ventas ajenas no envía nada) -->
        <span v-if="conexion.ventasEnColaUsuario > 0 && !conexion.modoOffline && !conexion.sincronizando"
              class="text-primary font-bold underline cursor-pointer" @click="sincronizar">Sincronizar ahora</span>
      </div>
      <ColaVentasLocal />
    </Dialog>
  </span>
</template>

<script>
import { useConexion } from '@/stores';
import { sincronizarAhora } from '@/services-offline/sincronizador';
import { AVISOS } from '@/config/offline';
import ColaVentasLocal from './ColaVentasLocal.vue';

// Etapa 3C: estado de la cola como botón «Ventas» en el encabezado del POS («Sincronizar ahora» va en el diálogo, no en el banner)
export default {
  name: 'ZapiEstadoSync',
  components: { ColaVentasLocal },
  data() {
    return { conexion: useConexion(), mostrarLista: false };
  },
  computed: {
    // Etapa 3D (A): ventas con más de 60 h (propias y ajenas): estado de mayor prioridad del botón
    hayAntiguas() {
      return this.conexion.ventasAntiguas > 0;
    },
    antiguasPropias() {
      return this.conexion.ventasAntiguas - this.conexion.ventasAntiguasAjenas;
    },
    enColaAjenas() {
      return this.conexion.ventasEnCola - this.conexion.ventasEnColaUsuario;
    },
    cajerosAjenos() {
      const n = this.conexion.cajerosConVentasAntiguas;
      return n.length > 1 ? `${n.slice(0, -1).join(', ')} y ${n[n.length - 1]}` : n.join('');
    },
    // Etapa 3D (B): reloj del equipo con más de 2 min de diferencia con el servidor
    relojDesfasado() {
      const d = this.conexion.desfaseVigente();
      return d !== null && Math.abs(d) > AVISOS.desfaseRelojMaxMs;
    },
    textoReloj() {
      const d = this.conexion.desfaseVigente() || 0;
      return `La hora del equipo está ${d > 0 ? 'adelantada' : 'atrasada'} ${Math.round(Math.abs(d) / 60000)} min: corríjala (Configuración de Windows › Hora › Sincronizar ahora)`;
    },
    hayAlerta() {
      const c = this.conexion;
      // Etapa 3D: antes return c.ventasRechazadas > 0 || c.syncSinPermiso || (c.sesionExpirada && c.ventasEnCola > 0);
      return this.hayAntiguas || this.relojDesfasado || c.ventasRechazadas > 0 || c.syncSinPermiso || (c.sesionExpirada && c.ventasEnCola > 0);
    },
    icono() {
      if (this.hayAntiguas) return 'pi pi-history'; // Etapa 3D (A)
      if (this.hayAlerta) return 'pi pi-exclamation-circle';
      if (this.conexion.sincronizando) return 'pi pi-spin pi-spinner';
      // D2 (a): antes this.conexion.ventasEnCola
      if (this.conexion.ventasEnColaUsuario > 0) return 'pi pi-clock';
      return 'pi pi-list';
    },
    numero() {
      const c = this.conexion;
      if (this.hayAntiguas) return String(c.ventasAntiguas); // Etapa 3D (A)
      if (c.ventasRechazadas > 0) return String(c.ventasRechazadas);
      if (this.hayAlerta) return '!';
      // D2 (a): antes if (c.ventasEnCola > 0) return String(c.ventasEnCola);
      if (c.ventasEnColaUsuario > 0) return String(c.ventasEnColaUsuario);
      return null;
    },
    severidad() {
      return this.hayAlerta ? 'danger' : 'warning';
    },
    claseBoton() {
      if (this.hayAlerta) return 'p-button-danger p-button-outlined';
      // D2 (a): antes this.conexion.ventasEnCola > 0
      if (this.conexion.sincronizando || this.conexion.ventasEnColaUsuario > 0) return 'p-button-warning p-button-outlined';
      return 'p-button-secondary p-button-text';
    },
    textoEstado() {
      const c = this.conexion;
      if (this.hayAntiguas) return `${c.ventasAntiguas} ventas con más de 60 h sin enviar: el servidor las rechaza a las 72 h`; // Etapa 3D (A)
      if (c.ventasRechazadas > 0) return `${c.ventasRechazadas} rechazadas: revise la lista`;
      if (this.relojDesfasado) return this.textoReloj; // Etapa 3D (B)
      if (c.syncSinPermiso) return 'Este usuario no tiene permiso para sincronizar ventas (Venta POS)';
      if (c.sesionExpirada && c.ventasEnCola > 0) return 'Sesión vencida: inicie sesión para enviarlas';
      // D2 (a): antes con c.ventasEnCola en las dos líneas siguientes
      if (c.sincronizando) return `Sincronizando ${c.ventasEnColaUsuario} ventas…`;
      if (c.ventasEnColaUsuario > 0) return `${c.ventasEnColaUsuario} por sincronizar`;
      return 'Ventas al día';
    }
  },
  methods: {
    sincronizar() {
      sincronizarAhora({ manual: true });
    }
  }
};
</script>
